// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingIndicator_container__1xera","fa":"LoadingIndicator_fa__3a2Dj","outer":"LoadingIndicator_outer__iwG5I","inner":"LoadingIndicator_inner__32jVB"};